"use client";

import type { ChatMessage } from "../types";

import { createContext, use } from "react";

export interface AIChatMessageContextValue {
  message: ChatMessage;
  index: number;
}

export const AIChatMessageContext =
  createContext<AIChatMessageContextValue | null>(null);

export function useAIChatMessageContext(): AIChatMessageContextValue {
  const ctx = use(AIChatMessageContext);
  if (!ctx) {
    throw new Error(
      "useAIChatMessageContext must be used within an AIChat.Message",
    );
  }
  return ctx;
}
